module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-2.4bc72d5b.webp";